import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {RouteReuseStrategy, RouterLink} from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicStorageModule } from "@ionic/storage-angular";
import {NgIf} from "@angular/common";
import { APP_INITIALIZER } from '@angular/core';
import { SharedDataService } from '../services/shared-data/shared-data.service';
import { WebAuthenticationService } from '../services/security/web-authentication.service';

export function initializeCache(sharedDataService: SharedDataService, authService: WebAuthenticationService) {
  return async () => {
    try {
      // Wait for auth service to be initialized
      await authService.init();
      
      // Get user context
      const user = await authService.getUser();
      const isAdmin = await authService.hasAdminAccess();
      const isCreator = await authService.hasCreatorAccess();
      
      // Initialize cache with proper context
      await sharedDataService.initializeCache(user, isAdmin, isCreator);
    } catch (error) {
      console.warn('Failed to initialize cache with user context:', error);
      // Fallback to basic initialization
      await sharedDataService.initializeCache();
    }
  };
}

@NgModule({
  declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        IonicStorageModule.forRoot(),
        IonicModule,
        NgIf,
        RouterLink
    ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeCache,
      deps: [SharedDataService, WebAuthenticationService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
